import React, { useEffect, useState } from "react";
import "./Permisos/Permisos.scss";

export default function ModalOrdenMenu({ visible, onHide, menuInicial, onGuardar }) {
    const [menu, setMenu] = useState([]);
    const [menuOriginal, setMenuOriginal] = useState([]);
    const [dragModulo, setDragModulo] = useState(null);
    const [dragSubMenu, setDragSubMenu] = useState(null);
    const [openModules, setOpenModules] = useState({});

    useEffect(() => {
        if (!visible) return;

        const copia = structuredClone(menuInicial || []);
        setMenu(copia);
        setMenuOriginal(structuredClone(copia));

        const abiertos = {};
        copia.forEach((item) => {
            abiertos[item.url] = true;
        });
        setOpenModules(abiertos);
    }, [visible, menuInicial]);

    const hayCambios = JSON.stringify(menu) !== JSON.stringify(menuOriginal);

    const moverElemento = (array, from, to) => {
        const copia = [...array];
        const [movido] = copia.splice(from, 1);
        copia.splice(to, 0, movido);
        return copia;
    };

    const toggleModulo = (url) => {
        setOpenModules((prev) => ({ ...prev, [url]: !prev[url] }));
    };

    // ═══════════════════════════════════════
    // Drag módulos
    // ═══════════════════════════════════════

    const handleModuloDragStart = (index) => {
        setDragModulo(index);
    };

    const handleModuloDrop = (indexDestino) => {
        if (dragModulo === null || dragModulo === indexDestino) return;

        setMenu((prev) => moverElemento(prev, dragModulo, indexDestino));
        setDragModulo(null);
    };

    // ═══════════════════════════════════════
    // Drag submenús
    // ═══════════════════════════════════════

    const handleSubMenuDragStart = (urlPadre, index) => {
        setDragSubMenu({ urlPadre, index });
    };

    const handleSubMenuDrop = (urlPadre, indexDestino) => {
        if (!dragSubMenu) return;
        if (dragSubMenu.urlPadre !== urlPadre) return;

        const nuevoMenu = structuredClone(menu);
        const modulo = nuevoMenu.find((x) => x.url === urlPadre);

        modulo.subMenu = moverElemento(modulo.subMenu, dragSubMenu.index, indexDestino);

        setMenu(nuevoMenu);
        setDragSubMenu(null);
    };

    // ═══════════════════════════════════════
    // Botones
    // ═══════════════════════════════════════

    const guardarCambios = () => {
        const jsonFinal = JSON.stringify(menu, null, 2);
        onGuardar({ menu, json: jsonFinal });
        setMenuOriginal(structuredClone(menu));
    };

    const revertirCambios = () => {
        const confirmar = window.confirm("¿Deseas restaurar el orden original?");
        if (!confirmar) return;

        setMenu(structuredClone(menuOriginal));
    };

    const cerrarModal = () => {
        if (hayCambios) {
            const confirmar = window.confirm("Tienes cambios sin guardar. ¿Deseas salir?");
            if (!confirmar) return;
        }

        onHide();
    };

    if (!visible) return null;

    return (
        <div className="menu-editor-modal">
            <div className="menu-modal">
                <div className="menu-modal-header">
                    <h2>Ordenar menú</h2>
                    <button className="close-btn" onClick={cerrarModal}>
                        ✕
                    </button>
                </div>

                <div className="menu-modal-body">
                    {menu.map((modulo, moduloIndex) => (
                        <div key={modulo.url} className="module-card">
                            <div
                                className="module-header"
                                draggable
                                onDragStart={() => handleModuloDragStart(moduloIndex)}
                                onDragOver={(e) => e.preventDefault()}
                                onDrop={() => handleModuloDrop(moduloIndex)}
                            >
                                <div className="module-left" onClick={() => toggleModulo(modulo.url)}>
                                    <span className="arrow">{openModules[modulo.url] ? "▼" : "▶"}</span>
                                    <span className="drag-icon">☰</span>
                                    <span>{modulo.title}</span>
                                </div>

                                <div className="module-count">{modulo.subMenu?.length}</div>
                            </div>

                            {openModules[modulo.url] && (
                                <div className="submenu-container">
                                    {modulo.subMenu?.map((sub, subIndex) => (
                                        <div
                                            key={sub.url}
                                            className="submenu-item"
                                            draggable
                                            onDragStart={() => handleSubMenuDragStart(modulo.url, subIndex)}
                                            onDragOver={(e) => e.preventDefault()}
                                            onDrop={() => handleSubMenuDrop(modulo.url, subIndex)}
                                        >
                                            <span className="submenu-drag">⋮</span>
                                            <span>{sub.title}</span>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    ))}
                </div>

                <div className="menu-modal-footer">
                    <div>
                        {hayCambios && <span className="warning-text">Cambios sin guardar</span>}
                    </div>

                    <div className="footer-buttons">
                        <button className="btn btn-warning" onClick={revertirCambios} disabled={!hayCambios}>
                            Revertir
                        </button>

                        <button className="btn btn-secondary" onClick={cerrarModal}>
                            Cerrar
                        </button>

                        <button className="btn btn-primary" onClick={guardarCambios} disabled={!hayCambios}>
                            Guardar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
